export const DATE_FORMATTING = 'd MMM yyyy';
export const DATE_TIME_FORMATTING = 'd MMM yyyy HH:mm';
export const FUSION_DATE_TIME_FORMATTING = 'yyyy-MM-dd hh:mm a';
export const TIME12_FORMATTING = 'h:mm a';
export const TIME24_FORMATTING = 'HH:mm';

export const DATE_FORMATTING_PIPE = 'dd MMM yyyy';
export const DATE_TIME_FORMATTING_PIPE = 'dd MMM yyyy HH:mm';
export const TIME12_FORMATTING_PIPE = 'h:mm a';
export const TIME24_FORMATTING_PIPE = 'HH:mm';

export const FILE_DATE_FORMAT = `yyyy-MM-dd'T00:00:00`;
export const FILE_DATE_TIME_FORMAT = `yyyy-MM-dd'T'HH:mm:ss`;
